import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportManagementReportFacade } from './transport-management-report.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementReportGuard {
  constructor(private transportManagementReportFacade: TransportManagementReportFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return checkStoreState(this.transportManagementReportFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportManagementReportFacade);
  }
}
